module.exports = __webpack_public_path__ + "static/media/CRUD.0974d983.JPG";